// Scale the unit to the magnitude so small amounts stay readable: anything
// under $1 renders in cents ($0.092 reads as `9.2¢`, $0.003678 as `0.37¢`).
// At/above $1 we keep the conventional 2-decimal dollar read (2 sig figs
// there would hide real money — $12.3456 -> $12).
export const formatCost = (val) => {
  if (val == null) return '-';
  const num = Number(val);
  if (isNaN(num)) return '-';
  if (num === 0) return '$0';

  const sign = num < 0 ? '-' : '';
  const abs = Math.abs(num);

  if (abs >= 1) return `${sign}$${abs.toFixed(2)}`;

  // Under a dollar: switch units. Round first, then floor on the rounded
  // value — comparing the raw product would misjudge the boundary ($1e-6
  // times 100 is 9.999999999999999e-05, not 0.0001) and, below the floor,
  // toPrecision flips to exponential notation that would leak `e-` into the
  // DOM.
  const cents = Number((abs * 100).toPrecision(2));
  // 0.9995+ rounds to 100¢ at 2 sig figs — show it as dollars instead.
  // Format from the rounded cents, not abs: 0.995 also lands here (its
  // float repr rounds up) but abs.toFixed(2) would print "$0.99".
  if (cents >= 100) return `${sign}$${(cents / 100).toFixed(2)}`;
  if (cents < 0.0001) return `${sign}<0.0001¢`;
  return `${sign}${cents}¢`;
};
